import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './thankyou.css';
import { useSelector } from 'react-redux';
import { selectAdminToken } from '../../admin/sessionSlice';
import { apiUrl } from '../../utils/apiUrl';
import { useMobileAppBrowserBackGuard } from '../../utils/useMobileAppBrowserBack';

const S3 = process.env.REACT_APP_S3_PATH || '';

function ThankYou() {
  const location = useLocation();
  const isFromMobileApp =
    new URLSearchParams(location.search).get('fromMobileApp') === 'true';
  useMobileAppBrowserBackGuard();

  const { user } = useSelector((state) => state.auth);
  const adminToken = useSelector(selectAdminToken);
  const { data: themeData } = useSelector((state) => state.theme);

  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !adminToken) return;
    let cancelled = false;

    (async () => {
      try {
        const resp = await fetch(apiUrl('/gameMatchUsers'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${adminToken}`,
          },
          body: JSON.stringify({ userId: user.userId }),
        });
        const data = await resp.json();
        if (!cancelled && data.success) {
          setMatches(data.matches || []);
        }
      } catch (e) {
        console.error('gameMatchUsers', e);
      }
      if (!cancelled) setLoading(false);
    })();

    return () => { cancelled = true; };
  }, [user, adminToken]);

  const gifSrc = themeData?.thank_you_page
    ? S3 + themeData.thank_you_page
    : '/thankyou.gif';

  const heading =
    themeData?.custom_text_thank_you_page || 'Thank you for playing!';
  const textColor =
    themeData?.text_color || themeData?.colors?.text_color || '#222';
  const btnBg =
    themeData?.button_backgroundcolor || '#8b4513';
  const btnText =
    themeData?.button_color || '#ffffff';

  const medals = ['🥇', '🥈', '🥉'];
  const barColors = ['#f59e0b', '#94a3b8', '#cd7f32'];

  return (
    <div className="ty-page">
      <div className="ty-inner">
        <img src={gifSrc} className="ty-gif" alt="" />

        <h2 className="ty-heading" style={{ color: textColor }}>
          {heading}
        </h2>

        <div className="ty-match-section">
          <h3 className="ty-match-title" style={{ color: btnBg }}>
            Your Taste Twins
          </h3>
          <p className="ty-match-subtitle">
            People who made the most similar choices as you
          </p>

          {loading ? (
            <div className="ty-loading">
              <div className="ty-spinner" />
              <span>Finding your taste twins…</span>
            </div>
          ) : matches.length === 0 ? (
            <div className="ty-no-matches">
              <p>No other players yet — be the first to share!</p>
            </div>
          ) : (
            <div className="ty-match-list">
              {matches.map((m, i) => (
                <div
                  className="ty-match-card"
                  key={m.userId || i}
                  style={{ '--bar-color': barColors[i] || '#6b7280' }}
                >
                  <div className="ty-match-rank">
                    <span className="ty-medal">{medals[i] || `#${i + 1}`}</span>
                  </div>
                  <div className="ty-match-info">
                    <div className="ty-match-name">{m.name}</div>
                    <div className="ty-match-bar-track">
                      <div
                        className="ty-match-bar-fill"
                        style={{ width: `${m.matchPercent}%` }}
                      />
                    </div>
                  </div>
                  <div
                    className="ty-match-pct"
                    style={{ color: btnBg }}
                  >
                    {m.matchPercent}%
                  </div>
                </div>
              ))}
            </div>
          )}

          <Link
            to={isFromMobileApp ? '/leaderboard?fromMobileApp=true' : '/leaderboard'}
            replace
            className="ty-leaderboard-btn"
            style={{ backgroundColor: btnBg, color: btnText }}
          >
            View Full Leaderboard
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
